// Palette de couleurs prédéfinies, choisies pour rester lisibles et distinctes (curseurs/avatars
// des utilisateurs distants). Tant qu'il reste une couleur non utilisée dans ce tableau, l'index de
// l'utilisateur y pioche directement — le résultat n'est donc plus vraiment aléatoire mais stable et
// prévisible. Au-delà de `PREDEFINED_COLORS.length` utilisateurs simultanés, on retombe sur une
// couleur aléatoire pour ne pas planter.
const PREDEFINED_COLORS = [
	'#457B9D', // bleu acier
	'#2A9D8F', // vert sarcelle
	'#9B5DE5', // violet
	'#F15BB5', // rose
	'#00BBF9', // bleu ciel
	'#00F5D4', // turquoise
	'#FFD166', // jaune doux
	'#8AC926', // vert pomme
	'#4D908E', // vert de gris
	'#6A4C93', // violet foncé
	'#118AB2', // bleu profond
	'#C77DFF', // mauve
];

export function randomColor(): string {
	const lettres = '0123456789ABCDEF';
	let couleur = '#';
	for (let i = 0; i < 6; i++) {
		couleur += lettres[Math.floor(Math.random() * 16)];
	}
	return couleur;
}

export default function getUserColor(index: number): string {
	return PREDEFINED_COLORS[index] ?? randomColor();
}

/**
 * Première couleur encore libre de la palette, aléatoire une fois celle-ci épuisée.
 *
 * Préférée à `getUserColor(index)` dès qu'une couleur doit rester stable : un index de position
 * change dès qu'un élément est ajouté ou retiré. Sert aux utilisateurs connectés (dont la couleur
 * doit être la même sur l'avatar, la pastille et le curseur) comme aux types de points d'intérêts,
 * auxquels on attribue une couleur distincte de celles déjà prises.
 */
export function pickFreeColor(usedColors: string[]): string {
	return PREDEFINED_COLORS.find(color => !usedColors.includes(color)) ?? randomColor();
}
